import { render, staticRenderFns } from "./ProcesspaintlistsPage.vue?vue&type=template&id=536388b8"
import script from "./ProcesspaintlistsPage.vue?vue&type=script&lang=js"
export * from "./ProcesspaintlistsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports